// Components/FloatingUpdate.jsx
import {
  Box,
  Flex,
  IconButton,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import DOMPurify from 'dompurify';
import { UPDATES } from './website_updates'; // ← 更新來源
import { useLanguage } from '../i18n/LanguageContext';

const FloatingUpdate = () => {
  const { t } = useLanguage();
  /** 找出第一則尚未被關閉的更新 */
  const getFirstVisibleUpdate = () =>
    UPDATES.find((u) => !localStorage.getItem(`dismiss_update_${u.id}`));

  const [current, setCurrent] = useState(() => getFirstVisibleUpdate());

  /** 關閉按鈕邏輯 */
  const handleClose = () => {
    if (!current) return;
    localStorage.setItem(`dismiss_update_${current.id}`, '1');
    setCurrent(getFirstVisibleUpdate()); // 若還有下一則，繼續顯示
  };

  /** RWD：手機全寬橫幅；桌機右下角卡片 */
  const isMobile = useBreakpointValue({ base: true, md: false });

  /* 若全部公告都被關閉，元件不渲染 */
  if (!current) return null;

  return (
    <Box
      position="fixed"
      zIndex="toast"
      bottom={isMobile ? 0 : 6}
      right={isMobile ? 0 : 6}
      left={isMobile ? 0 : 'auto'}
      bg="blue.500"
      color="white"
      boxShadow="lg"
      borderRadius={isMobile ? 0 : 'md'}
      p={4}
      w={isMobile ? '100%' : '600px'}
    >
      <Flex justify="space-between">
        {/* 文字區塊 */}
        <Box pr={3}>
          {/* 標題：支援 HTML，並以 DOMPurify 消毒避免 XSS */}
          <Text textAlign="left"
            as="div"
            fontWeight="bold"
            fontSize={{ base: 'xl', md: '2xl' }}
            mb={3}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(current.title || ''),
            }}
          />

          {/* 內文 */}
          <Text
            fontSize={{ base: 'md', md: 'lg' }}
            whiteSpace="pre-wrap"
            mb={3}
          >
            {current.body}
          </Text>

          {/* 日期 */}
          <Text textAlign="left" fontSize={{ base: 'md', md: 'lg' }} color="whiteAlpha.700">
            {current.date}
          </Text>
        </Box>

        {/* 關閉按鈕 */}
        <IconButton
          aria-label={t('common.dismissUpdate')}
          icon={<CloseIcon />}
          size="sm"
          variant="ghost"
          colorScheme="whiteAlpha"
          onClick={handleClose}
        />
      </Flex>
    </Box>
  );
};

export default FloatingUpdate;
